import { inTenMinutes } from '../lib/helpers'

export const state = () => ({
  loginAttempts: 0,
  loginAttemptsExpiry: null,
  passwordResetAttempts: 0,
  passwordResetAttemptsExpiry: null,
})

export const getters = {
  remainingLoginAttempts(state) {
    const remaining = 3 - state.loginAttempts
    return remaining >= 0 ? remaining : 0
  },
  remainingPasswordResets(state) {
    const remaining = 3 - state.passwordResetAttempts
    return remaining >= 0 ? remaining : 0
  },
}

export const mutations = {
  incrementLoginAttempts(state) {
    state.loginAttempts++
    state.loginAttemptsExpiry = inTenMinutes()
  },
  resetLoginAttempts(state) {
    state.loginAttempts = 0
    state.loginAttemptsExpiry = null
  },
  incrementPasswordResetAttempts(state) {
    state.passwordResetAttempts++
    state.passwordResetAttemptsExpiry = inTenMinutes()
  },
  resetPasswordResetAttempts(state) {
    state.passwordResetAttempts = 0
    state.passwordResetAttemptsExpiry = null
  },
}
